import { defineMessages } from 'react-intl';

// Main route
const transactionsScope = 't.page.transactions';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	// Transaction Scope
	transactionId: {
		id: `${transactionsScope}.transactionId`,
		defaultMessage: 'ID Transazione',
	},
	merchantId: {
		id: `${transactionsScope}.merchantId`,
		defaultMessage: 'Merchant',
	},
	merchantName: {
		id: `${transactionsScope}.merchantName`,
		defaultMessage: 'Merchant',
	},
	currency: {
		id: `${transactionsScope}.currency`,
		defaultMessage: 'Valuta',
	},
	amount: {
		id: `${transactionsScope}.amount`,
		defaultMessage: 'Importo',
	},
	creationDate: {
		id: `${transactionsScope}.creationDate`,
		defaultMessage: 'Data',
	},
	transactionStatus: {
		id: `${transactionsScope}.transactionStatus`,
		defaultMessage: 'Stato Transazione',
	},
	transactionChannel: {
		id: `${transactionsScope}.paymentChannel`,
		defaultMessage: 'Canale di pagamento',
	},
	paymentMethod: {
		id: `${transactionsScope}.paymentMethod`,
		defaultMessage: 'Metodo di pagamento',
	},
	userId: {
		id: `${transactionsScope}.userId`,
		defaultMessage: 'Utente',
	},
	storeId: {
		id: `${transactionsScope}.storeId`,
		defaultMessage: 'Negozio',
	},
	registerId: {
		id: `${transactionsScope}.registerId`,
		defaultMessage: 'Cassa',
	},
	terminalId: {
		id: `${transactionsScope}.terminalId`,
		defaultMessage: 'Terminale',
	},
	groupId: {
		id: `${transactionsScope}.groupId`,
		defaultMessage: 'Gruppo',
	},
	detailTitle: {
		id: `${transactionsScope}.detailTitle`,
		defaultMessage: 'Dettaglio transazione',
	},
	transactionData: {
		id: `${transactionsScope}.transactionData`,
		defaultMessage: 'Dati transazione',
	},
	typeOfPayment: {
		id: `${transactionsScope}.typeOfPayment`,
		defaultMessage: 'Tipologia pagamento',
	},
	orderData: {
		id: `${transactionsScope}.orderData`,
		defaultMessage: 'Dati ordine',
	},
	creditCardTransaction: {
		id: `${transactionsScope}.creditCardTransaction`,
		defaultMessage: 'Transazioni carta di credito',
	},
	walletTransaction: {
		id: `${transactionsScope}.walletTransaction`,
		defaultMessage: 'Transazioni borsellino',
	},
	apmTransaction: {
		id: `${transactionsScope}.apmTransaction`,
		defaultMessage: 'Transazioni APM',
	},
	acquierResponse: {
		id: `${transactionsScope}.acquierResponse`,
		defaultMessage: 'Acquirer Response',
	},
	orderId: {
		id: `${transactionsScope}.orderId`,
		defaultMessage: 'ID Ordine',
	},
	orderChannel: {
		id: `${transactionsScope}.orderChannel`,
		defaultMessage: 'Canale Ordine',
	},
	description: {
		id: `${transactionsScope}.description`,
		defaultMessage: 'Descrizione Estesa',
	},
	acquirer: {
		id: `${transactionsScope}.acquirer`,
		defaultMessage: 'Acquirer',
	},
	acquirerTransactionId: {
		id: `${transactionsScope}.acquirerTransactionId`,
		defaultMessage: 'Id Transazione Acquirer',
	},
	authorizationCode: {
		id: `${transactionsScope}.authorizationCode`,
		defaultMessage: 'Codice autorizzazione',
	},
	authorizationStatus: {
		id: `${transactionsScope}.authorizationStatus`,
		defaultMessage: 'Stato autorizzazione',
	},
	walletCode: {
		id: `${transactionsScope}.walletCode`,
		defaultMessage: 'Codice borsellino',
	},
	cardCode: {
		id: `${transactionsScope}.cardCode`,
		defaultMessage: 'Codice carta',
	},
	callType: {
		id: `${transactionsScope}.callType`,
		defaultMessage: 'Stato transazione',
	},
	request: {
		id: `${transactionsScope}.request`,
		defaultMessage: 'Request',
	},
	response: {
		id: `${transactionsScope}.response`,
		defaultMessage: 'Response',
	},
	circuit: {
		id: `${transactionsScope}.circuit`,
		defaultMessage: 'Circuito',
	},
	pan: {
		id: `${transactionsScope}.pan`,
		defaultMessage: 'PAN',
	},
	REJECTED: {
		id: `${transactionsScope}.REJECTED`,
		defaultMessage: 'Rifiutata',
	},
	REVERSED: {
		id: `${transactionsScope}.REVERSED`,
		defaultMessage: 'Stornata',
	},
	ACCOUNTED: {
		id: `${transactionsScope}.ACCOUNTED`,
		defaultMessage: 'Transazione contabilizzata',
	},
	TO_BE_REVERSED: {
		id: `${transactionsScope}.TO_BE_REVERSED`,
		defaultMessage: 'Da stornare',
	},
	AUTHORIZED: {
		id: `${transactionsScope}.AUTHORIZED`,
		defaultMessage: 'Autorizzata',
	},
	NOT_AUTHORIZED: {
		id: `${transactionsScope}.NOT_AUTHORIZED`,
		defaultMessage: 'Non autorizzata',
	},
	EXPIRED: {
		id: `${transactionsScope}.EXPIRED`,
		defaultMessage: 'Scaduta',
	},
	REFUNDED: {
		id: `${transactionsScope}.REFUNDED`,
		defaultMessage: 'Rimborsata',
	},
	CANCELED: {
		id: `${transactionsScope}.CANCELED`,
		defaultMessage: 'Cancellata',
	},
	CANCELLED: {
		id: `${transactionsScope}.CANCELLED`,
		defaultMessage: 'Cancellata',
	},
	PARTIAL_REFUNDED: {
		id: `${transactionsScope}.PARTIAL_REFUNDED`,
		defaultMessage: 'Parzialmente rimborsata',
	},
	AUTHORIZING: {
		id: `${transactionsScope}.AUTHORIZING`,
		defaultMessage: 'In autorizzazione',
	},
	TO_BE_AUTHORIZED: {
		id: `${transactionsScope}.TO_BE_AUTHORIZED`,
		defaultMessage: 'Da autorizzare',
	},
	NOT_REVERSED_FOR_ERRORS: {
		id: `${transactionsScope}.NOT_REVERSED_FOR_ERRORS`,
		defaultMessage: 'Non stornata per errori',
	},
	CARDS: {
		id: `${transactionsScope}.CARDS`,
		defaultMessage: 'Carta',
	},
  CARDSCOMBINED: {
    id: `${transactionsScope}.CARDSCOMBINED`,
    defaultMessage: 'Carta Combinato',
  },
	PAYPAL: {
		id: `${transactionsScope}.PAYPAL`,
		defaultMessage: 'Paypal',
	},
	PAYPALCOMBINED: {
		id: `${transactionsScope}.PAYPALCOMBINED`,
		defaultMessage: 'Paypal combinato',
	},
	GOOGLEPAY: {
		id: `${transactionsScope}.GOOGLEPAY`,
		defaultMessage: 'GooglePay',
	},
	GOOGLEPAY_COMBINED: {
		id: `${transactionsScope}.GOOGLEPAY_COMBINED`,
		defaultMessage: 'GooglePay combinato',
	},
	APPLEPAY: {
		id: `${transactionsScope}.APPLEPAY`,
		defaultMessage: 'ApplePay',
	},
	APPLEPAY_COMBINED: {
		id: `${transactionsScope}.APPLEPAY_COMBINED`,
		defaultMessage: 'ApplePay combinato',
	},
	EPURSE: {
		id: `${transactionsScope}.EPURSE`,
		defaultMessage: 'Borsellino',
	},
	CASH: {
		id: `${transactionsScope}.CASH`,
		defaultMessage: 'Contanti',
	},
	LOYALTY: {
		id: `${transactionsScope}.LOYALTY`,
		defaultMessage: 'Loyalty',
	},
	ACCOUNTING_TRANSFER: {
		id: `${transactionsScope}.ACCOUNTING_TRANSFER`,
		defaultMessage: 'Trasferimento Contabile',
	},
	RECHARGE: {
		id: `${transactionsScope}.RECHARGE`,
		defaultMessage: 'Ricarica',
	},
	PAYMENT: {
		id: `${transactionsScope}.PAYMENT`,
		defaultMessage: 'Pagamento',
	},
	ENROLLMENT: {
		id: `${transactionsScope}.ENROLLMENT`,
		defaultMessage: 'Enrollment',
	},
	accounted: {
		id: `${transactionsScope}.accounted`,
		defaultMessage: 'Contabilizzato',
	},
	toReverse: {
		id: `${transactionsScope}.toReverse`,
		defaultMessage: 'Da Stornare',
	},
	managePostAccounting: {
		id: `${transactionsScope}.managePostAccounting`,
		defaultMessage: 'Gestione Storni Post Contabilizzazione',
	},
	editAmount: {
		id: `${transactionsScope}.editAmount`,
		defaultMessage: 'Importo da stornare',
	},
	reverse: {
		id: `${transactionsScope}.reverse`,
		defaultMessage: 'Storna',
	},
  	order: {
		id: `${transactionsScope}.order`,
		defaultMessage: 'Importo ordine: ',
	},
	alreadyreversed: {
		id: `${transactionsScope}.alreadyreversed`,
		defaultMessage: 'Importo già stornato: ',
	},

	// Navigation Scope
	transactionList: {
		id: `${navigationScope}.transactions.transactionList`,
		defaultMessage: 'Elenco transazioni',
	},
	postAccountingTransfer: {
		id: `${navigationScope}.transactions.postAccountingTransfer`,
		defaultMessage: 'Storno post contabilizzazione',
	},

	// Global Scope
	reportXls: {
		id: `${globalScope}.reportXls`,
		defaultMessage: 'Report XLS',
	},
	from: {
		id: `${globalScope}.from`,
		defaultMessage: 'Da',
	},
	to: {
		id: `${globalScope}.to`,
		defaultMessage: 'A',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},

	//Global errors
	invalidDate: {
		id: `${globalErrorsScope}.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
	invalidEmail: {
		id: `${globalErrorsScope}.invalidEmail`,
		defaultMessage: 'Email non valida',
	},
	maxAmount: {
		id: `${globalErrorsScope}.maxAmount`,
		defaultMessage: 'Superato importo massimo consentito',
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
		defaultMessage: 'Superata lunghezza massima',
	}
});
